// import { configureStore } from '@reduxjs/toolkit';
// import { combineReducers } from 'redux';
// import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import userReducer from './userSlice';

// const rootReducer = combineReducers({
//   user: userReducer,
// });

// const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['user'],
//   // **ADD THIS: Helps with debugging**
//   debug: true,
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }),
// });

// export const persistor = persistStore(store);

// // **ADD THIS: Optional - Add a function to manually purge**
// export const purgePersistor = async () => {
//   await persistor.purge();
//   await persistor.flush();
// };

import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './userSlice';

const rootReducer = combineReducers({
  user: userReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
  debug: true,
  // ✅ ADDED: Version control to force clear cached data when needed
  version: 2,
  // ✅ ADDED: Migrate function to handle state transformations
  migrate: (state) => {
    // Clear state if version mismatch or invalid data
    if (!state || !state._persist) {
      return Promise.resolve(undefined);
    }
    return Promise.resolve(state);
  },
  // ✅ ADDED: Timeout to prevent hanging
  timeout: 10000,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// ✅ UPDATED: Enhanced purge function with localStorage cleanup
export const purgePersistor = async () => {
  try {
    console.log('🧹 Purging persistor...');
    await persistor.purge();
    await persistor.flush();
    // Also clear the persist:root from localStorage
    localStorage.removeItem('persist:root');
    console.log('✅ Persistor purged successfully');
  } catch (error) {
    console.error('❌ Error purging persistor:', error);
  }
};